import { render } from "./floatPanel.vue?vue&type=template&id=4f5d424f"
import script from "./floatPanel.vue?vue&type=script&lang=js"
export * from "./floatPanel.vue?vue&type=script&lang=js"

import "./floatPanel.vue?vue&type=style&index=0&id=4f5d424f&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__